module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./LogisticsView.js"));
	}, "LogisticsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=LogisticsView!./src/pages/Shop/Member/TradeManage/OrderList/Detail/Logistics/LogisticsView.js
// module id = 1956
// module chunks = 367